module.exports = __webpack_public_path__ + "img/emoji-angry-fill.7f9e7b4b.svg";